import type { ScheduleState } from '../types';

const selectDatesStatus = (state: ScheduleState) => state.datesStatus;

export { selectDatesStatus };
